import React, { useState } from "react"
import styled from "styled-components";
import Logo from "../common/assets/logo.png"
import Menu from "../common/assets/icons8-menu.png"
import Close from "../common/assets/icons8-close.png"

const HeaderWrapper = styled.div`
    height: 100px;
    width: calc(100% - 16vw);
    padding: 0 8vw;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    z-index: 999;
    background-color: #fff;

    display: flex;
    align-items: center;
    justify-content: space-between;
    
    img{
        max-height: 50px;
        @media screen and (max-width: 1000px){
            height: 35px;
        }
        @media screen and (max-width: 400px){
            height: 24px;
        }
    }

    .responsive-menu{
        @media screen and (max-width: 800px){
            width: 100vw;
            
            display: ${(props) => (props.isMenuOpen ? 'flex' : 'none')} !important;
            position: absolute;
            top: 100px;
            left:0;
            flex-direction: column;
            .menu-items{
                color: #fff;
                border-top: 1px solid #fff;
                text-align: center;
                margin-left: 0 !important;
                padding: 16px 0;
                background-color: #44647c;
                
                &:hover {
                background-color: #053050;
                }
            }
        }
        @media screen and (min-width: 800px){
            display: none;
        }
    }

    #menu{
        display:flex;
        color: #053050;
        font-weight: 550;
        @media screen and (max-width: 800px){
            display: none;
         }
         .menu-items{
             margin-left: 32px;
             cursor: pointer;
         }
    }

    #menu-icon{
        background-color: #053050;
        padding: 4px;
        border-radius: 8px;
        cursor: pointer;
        transition: background-color 0.3s ease;
        color: #fff;
        font-size: 24px;
        display:flex;
        align-items:center;
        justify-content: center;
        img{
            height: 30px;
        }
        #close-button{
            rotate: 45deg;
        }
        &:hover {
            background-color: #44647c;
        }
        @media screen and (min-width: 800px){
            display: none;
        }
        @media screen and (max-width: 400px){
            height: 24px;
        }
    }

`

const Header = ({ handleMenuClick }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const expandMenu = () => {
        setIsMenuOpen(true);
    }

    const closeMenu = () => {
        setIsMenuOpen(false);
    }

    const handleMenu = (name)=>{
        closeMenu();
        handleMenuClick(name);
    }
    return (
        <HeaderWrapper isMenuOpen={isMenuOpen}>
            <img src={Logo} alt="Logo" />
            <div id="menu-icon">

                {isMenuOpen ?
                    <img src={Close} alt="Close" onClick={closeMenu} />
                    :
                    <img src={Menu} alt="menu" onClick={expandMenu}/>
                }
            </div>
            <div id="menu" className="responsive-menu">
                <span className="menu-items" onClick={() => handleMenu('home')}>Home</span>
                <span className="menu-items" onClick={() => handleMenu('about-us')}>About Us</span>
                <span className="menu-items" onClick={() => handleMenu('contact-us')}>Contact Us</span>
            </div>
        </HeaderWrapper>
    )
}

export default Header;